import styled from 'styled-components';

export const EmployeeAvatar = styled.img`
  width: 125px;
  height: 125px;
  border-radius: 50%;
  border: 2px solid white;
  -webkit-border-radius: 100px;
  -webkit-background-clip: padding-box;
  -moz-border-radius: 100px;
  -moz-background-clip: padding;
  border-radius: 100px;
  background-clip: padding-box;
  float: left;
  background-size: cover;
  background-position: center center;
`;

export const EmployeeAvatarLoadingDiv = styled.div`
  width: 100px;
  height: 100px;
  -webkit-border-radius: 100px;
  -webkit-background-clip: padding-box;
  -moz-border-radius: 100px;
  -moz-background-clip: padding;
  border-radius: 100px;
  background-clip: padding-box;
  margin: 7px 0 0 5px;
  float: left;
  img {
    border-radius: 50%;
    border: 4px solid red;
    width: 100%;
    height: 100%;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const ImgContainer = styled.div`
  position: relative;
  display: inline-block;
  height: 100px;
  cursor: pointer;
  :hover {
    div:nth-child(2) {
      display: flex;
    }
  }
`;

export const EditIconContainer = styled.div`
  position: absolute;
  display: none;
  align-items: center;
  justify-content: center;
  top: 3px;
  right: 0px;
  font-size: 14px;
  background-color: #4948ac;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 2px solid white;
`;

export const EditIcon = styled.img`
  width: 10px;
  height: auto;
`;
